export type Sponsor = {
    name: string
    image: string
    url?: string
}

const getSponsors = (): Sponsor[] => {
    return [
        {
            name: 'GRADIENT a.s.',
            image: 'assets/img/sponsors/gradient.jpeg',
            url: 'http://www.gradient.cc/',
        },
        {
            name: 'BLAŽEJ JAROSLAV - výroba strojů a zařízení s.r.o.',
            image: 'assets/img/sponsors/jaroslav_blazej.png',
        },
        {
            name: 'La Lorraine',
            image: 'assets/img/sponsors/la_lorraine.jpg',
            url: 'https://www.lalorraine.com/cz-cs',
        },
    ]
}

export const useSponsors = (): Sponsor[] => {
    const sponsors = getSponsors()

    return sponsors
}
